import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';
import axios from 'axios';
import useGlobalUrl from './useGlobalUrl';

const { rootUrl } = useGlobalUrl();
const { addAlert } = useAlerts();

const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($userid: ID!, $user: TBL_USERS_Input!) {
    updateUser(userid: $userid, user: $user)
  }
`;

const ADD_USER_MUTATION = gql`
  mutation AddUser($user: TBL_USERS_Input!) {
    addUser(user: $user)
  }
`;

const DELETE_USER_MUTATION = gql`
  mutation DeleteUser($userid: ID!) {
    deleteUser(userid: $userid)
  }
`;

export default function useUpdateUser() {
  async function updateUser(userid, user) {
    const { mutate, loading, error } = useMutation(UPDATE_USER_MUTATION);

    try {
      const removeTypename = { ...user, __typename: undefined, USERID: undefined };
      const { data } = await mutate({ userid, user: removeTypename });
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error updating user:', error);
      addAlert('Error updating user', 'high', 4);
    }
  }

  async function addUser(user) {
    const { mutate, loading, error } = useMutation(ADD_USER_MUTATION);
    try {
      const removeTypename = { ...user, __typename: undefined, USERID: undefined };
      const { data } = await mutate({ user: removeTypename });
      console.log(data);
      return data;
    } catch (error) {
      console.error('Error adding user:', error);
      addAlert('Error adding user', 'high', 4);
    }
  }

  async function deleteUser(userid) {
    const { mutate, loading, error } = useMutation(DELETE_USER_MUTATION);
    try {
      await mutate({ userid });
      return true;
    } catch (error) {
      console.error('Error deleting user:', error);
      addAlert('Error deleting user', 'high', 4);
      return false;
    }
  }

  return {
    updateUser,
    addUser,
    deleteUser,
  };
}
